import { ReactElement, ReactNode } from 'react'
import { GoogleTagManager } from '@next/third-parties/google'
import fs from 'fs'
import { NextPage } from 'next'
import { type AppContext, type AppProps, default as NextApp } from 'next/app'
import path from 'path'

import Loader from '@/components/base/Loader'
import SVGSprites from '@/components/base/SVGSprites'
import { Store, StoreProvider } from '@/contexts/store'
import { ThemeProvider } from '@/contexts/theme'

import '@/styles/globals.css'

import '@/base/gsap'

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  // eslint-disable-next-line no-unused-vars
  getLayout?: (page: ReactElement, props: AppProps) => ReactNode
}

export default function App({
  Component,
  pageProps,
  menu,
  strings
}: AppProps & Store & { Component: NextPageWithLayout }) {
  const getLayout = Component.getLayout ?? ((page) => page)

  return (
    <>
      <StoreProvider menu={menu} strings={strings}>
        <Loader />
        <ThemeProvider theme={pageProps?.acf?.theme}>
          {getLayout(<Component {...pageProps} />, pageProps)}
          <SVGSprites />
        </ThemeProvider>
      </StoreProvider>
      {process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_GTM && (
        <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GTM} />
      )}
    </>
  )
}

App.getInitialProps = async (appContext: AppContext) => {
  const appProps = await NextApp.getInitialProps(appContext)
  const filePath = path.join(process.cwd(), '/data/options.json')
  const options = JSON.parse(fs.readFileSync(filePath, 'utf-8'))

  return {
    ...appProps,
    strings: options
  }
}
